import React from 'react';
import Head from 'next/head';

import { applicationSettings } from '@/constants';
import { getArticleDetails, getArticlesByPage } from '@/helpers/helpers_data';
import ArticleCardsWithImage from '@/components/ArticleCardsWithImage';
import ArticleCopy from '@/components/ArticleCopy';
import ArticleCTA from '@/components/ArticleCTA';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Hero from '@/components/Hero';
import StickyPhoneBubble from '@/components/StickyPhoneBubble';
import { CATEGORY_SUBSETS } from '@/contexts/categories_subset';

const { CALLAPRO_WEBSITE_URL } = applicationSettings;

const ARTICLES_PER_PAGE = 10;

export async function getStaticPaths() {
  const paths = [];

  // Get all blog articles.
  const data = await getArticlesByPage({ limit: 1000 });

  CATEGORY_SUBSETS.map((category) => {
    data.articles
      .filter((article) => !category.exclude_from_popular_categories && article.category_name === category.name)
      .map((article) => {
        paths.push({
          params: {
            category: category.url_slug,
            article: article.url_slug
          }
        });
      });
  });

  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  // Need to convert the category url_slug into the friend name to retrieve articles from the blog API.
  const categoryName = CATEGORY_SUBSETS.filter((category) => !category.exclude_from_popular_categories && category.url_slug === params.category)[0].name;

  const data = await getArticlesByPage({ limit: ARTICLES_PER_PAGE, category: categoryName });

  const article = await getArticleDetails({
    category_slug: params.category,
    url_slug: params.article
  });
  return {
    props: {
      article: article,
      articles: data.articles,
      category: CATEGORY_SUBSETS.filter((category) => category.url_slug === params.category)[0],
      total_articles: data.total
    }
  };
}

const Article = ({ article = {}, articles = [], category }) => (
  <div className="page-wrapper">
    <Head>
      <title>{article.title || 'Find Home Service Pros Near You'}</title>
      <meta name="description" content={article.description || 'CallAPro - Find a Home Service Professional Near You'} />

      {article.keywords && <meta name="keywords" content={article.keywords} />}
      {article.og_description && <meta name="og:description" content={article.og_description} />}
      {article.og_title && <meta name="og:title" content={article.og_title} />}
      {article.og_image_src && <meta name="og:image" content={article.og_image_src} />}

      <meta name="og:url" content={`${CALLAPRO_WEBSITE_URL}/news/${article.category_slug}/faq/${article.url_slug}/`} />

      <link rel="canonical" href={`${CALLAPRO_WEBSITE_URL}/news/${article.category_slug}/faq/${article.url_slug}/`} />
    </Head>
    <Header />
    <ArticleCTA category={category} />
    {article.content && <ArticleCopy {...article} category={category} />}
    <StickyPhoneBubble category={category} />
    <Hero />
    <ArticleCardsWithImage articles={articles.slice(0, 3)} headline={`Recent ${category.name_singular} Articles`} />
    <Footer />
  </div>
);

export default Article;
